document.addEventListener('DOMContentLoaded', function () {
  const certificates = document.querySelectorAll('.as-certificate');

  certificates.forEach(function (certificate) {
    const infoButton = certificate.querySelector('.as-certificate__info');
    const closeButton = certificate.querySelector('.as-certificate__close');

    if (!infoButton) return;

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        certificate.classList.remove('is-open');
        infoButton.setAttribute('aria-expanded', 'false');
        infoButton.focus();
      });
    }

    infoButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const isOpen = certificate.classList.contains('is-open');

      document.querySelectorAll('.as-certificate.is-open').forEach(function (item) {
        item.classList.remove('is-open');

        const button = item.querySelector('.as-certificate__info');
        if (button) button.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        certificate.classList.add('is-open');
        infoButton.setAttribute('aria-expanded', 'true');
      }
    });
  });

  document.addEventListener('click', function (event) {
    document.querySelectorAll('.as-certificate.is-open').forEach(function (certificate) {
      if (!certificate.contains(event.target)) {
        certificate.classList.remove('is-open');

        const button = certificate.querySelector('.as-certificate__info');
        if (button) button.setAttribute('aria-expanded', 'false');
      }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('.as-certificate.is-open').forEach(function (certificate) {
        certificate.classList.remove('is-open');

        const button = certificate.querySelector('.as-certificate__info');
        if (button) {
          button.setAttribute('aria-expanded', 'false');
          button.focus();
        }
      });
    }
  });
});